(function () {
  function init(root) {
    var sid = root.getAttribute('data-rz');
    var dataEl = document.getElementById('rz-data-' + sid);
    if (!dataEl) return;

    var data = JSON.parse(dataEl.textContent);
    var variants = data.variants || [];

    function money(cents) {
      var n = (cents / 100).toFixed(2);
      var f = data.moneyFormat || '';
      if (!f) return n;
      return f
        .replace(/\{\{\s*amount\s*\}\}/, n)
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/, String(Math.round(cents / 100)))
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, n.replace('.', ','))
        .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, String(Math.round(cents / 100)))
        .replace(/<[^>]*>/g, '');
    }

    function packSize(label) {
      var m = String(label).match(/\d+/);
      return m ? parseInt(m[0], 10) : 1;
    }

    function byId(prefix) {
      return document.getElementById(prefix + '-' + sid);
    }

    /* gallery */
    var gal = byId('rz-gal');
    var thumbWrap = byId('rz-thumbs');
    var thumbs = thumbWrap ? [].slice.call(thumbWrap.querySelectorAll('.rz-thumb')) : [];
    var slides = gal ? [].slice.call(gal.querySelectorAll('.rz-slide')) : [];

    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        var key = t.getAttribute('data-go');
        slides.forEach(function (s) {
          s.classList.toggle('on', s.getAttribute('data-slide') === key);
        });
        thumbs.forEach(function (x) {
          x.setAttribute('aria-pressed', String(x.getAttribute('data-go') === key));
        });
      });
    });

    /* countdown */
    var timerEl = byId('rz-timer');
    if (timerEl) {
      var clockEl = byId('rz-clock');
      var end = new Date(timerEl.getAttribute('data-end')).getTime();
      var pad = function (n) { return (n < 10 ? '0' : '') + n; };
      (function tick() {
        var left = end - Date.now();
        if (isNaN(end) || left <= 0) {
          timerEl.className = 'rz-timer done';
          timerEl.textContent = data.timerEndedLabel || 'Launch price has ended.';
          return;
        }
        var d = Math.floor(left / 86400000),
          h = Math.floor(left / 3600000) % 24,
          m = Math.floor(left / 60000) % 60,
          s = Math.floor(left / 1000) % 60;
        clockEl.textContent = (d > 0 ? d + 'd ' : '') + pad(h) + ':' + pad(m) + ':' + pad(s);
        setTimeout(tick, 1000);
      })();
    }

    /* variant selection */
    var sel1 = null, sel2 = null;
    var swBtns = [].slice.call(root.querySelectorAll('.rz-sw'));
    var tierBtns = [].slice.call(root.querySelectorAll('.rz-tier'));

    swBtns.forEach(function (b) {
      if (b.getAttribute('aria-pressed') === 'true') sel1 = b.getAttribute('data-opt1');
    });
    tierBtns.forEach(function (b) {
      if (b.getAttribute('aria-pressed') === 'true') sel2 = b.getAttribute('data-opt2');
    });

    function findVariant(o1, o2) {
      for (var i = 0; i < variants.length; i++) {
        var vv = variants[i];
        if ((o1 === null || vv.o1 === o1) && (o2 === null || vv.o2 === o2)) return vv;
      }
      return null;
    }

    var elNow = byId('rz-now'),
      elWas = byId('rz-was'),
      elOff = byId('rz-off'),
      elUnit = byId('rz-unit'),
      elVid = byId('rz-vid'),
      elAtc = byId('rz-atc');
    var form = elAtc ? elAtc.closest('form') : null;

    var sticky = byId('rz-sticky'),
      skNow = byId('rz-sk-now'),
      skWas = byId('rz-sk-was'),
      skSub = byId('rz-sk-sub'),
      skBtn = byId('rz-sk-btn');

    var current = null;

    function render() {
      tierBtns.forEach(function (b) {
        var vv = findVariant(sel1, b.getAttribute('data-opt2'));
        var priceEl = b.querySelector('.rz-tprice');
        var wasEl = b.querySelector('.rz-twas');
        var saveEl = b.querySelector('.rz-tsave');
        if (!vv) { b.style.opacity = '.45'; return; }
        b.style.opacity = vv.available ? '1' : '.45';
        priceEl.textContent = money(vv.price);
        var pn = packSize(vv.o2 || vv.title);
        if (vv.compare > vv.price) {
          wasEl.textContent = money(vv.compare);
          saveEl.textContent =
            money(Math.round(vv.price / pn)) + ' ' + data.eachLabel +
            ' \u00b7 ' + Math.round((1 - vv.price / vv.compare) * 100) + '% ' + data.saveLabel;
        } else {
          wasEl.textContent = '';
          saveEl.textContent = vv.available
            ? money(Math.round(vv.price / pn)) + ' ' + data.eachLabel
            : data.soldOutLabel;
        }
      });

      var cur = findVariant(sel1, sel2);
      if (!cur) cur = findVariant(sel1, null) || variants[0];
      if (!cur) return;
      current = cur;

      elNow.textContent = money(cur.price);
      if (cur.compare > cur.price) {
        elWas.style.display = '';
        elOff.style.display = '';
        elWas.textContent = money(cur.compare);
        elOff.textContent =
          Math.round((1 - cur.price / cur.compare) * 100) + '% ' + String(data.saveLabel).toUpperCase();
      } else {
        elWas.style.display = 'none';
        elOff.style.display = 'none';
      }

      var n = packSize(cur.o2 || cur.title);
      elUnit.innerHTML =
        '<b>' + n + ' ' + (n === 1 ? data.unitOne : data.unitMany) + '</b> | ' +
        money(Math.round(cur.price / n)) + ' ' + data.eachLabel;

      elVid.value = cur.id;
      elAtc.disabled = !cur.available;
      elAtc.textContent = cur.available
        ? data.atcLabel + ' \u2014 ' + money(cur.price)
        : data.soldOutLabel;

      if (sticky) {
        skNow.textContent = money(cur.price);
        skWas.textContent = cur.compare > cur.price ? money(cur.compare) : '';
        skSub.textContent = cur.title;
        skBtn.disabled = !cur.available;
        skBtn.textContent = cur.available ? data.atcLabel : data.soldOutLabel;
      }
    }

    swBtns.forEach(function (b) {
      b.addEventListener('click', function () {
        swBtns.forEach(function (x) { x.setAttribute('aria-pressed', 'false'); });
        b.setAttribute('aria-pressed', 'true');
        sel1 = b.getAttribute('data-opt1');
        render();
      });
    });

    tierBtns.forEach(function (b) {
      b.addEventListener('click', function () {
        tierBtns.forEach(function (x) { x.setAttribute('aria-pressed', 'false'); });
        b.setAttribute('aria-pressed', 'true');
        sel2 = b.getAttribute('data-opt2');
        render();
      });
    });

    /* add to cart
       No custom events are dispatched here. Horizon renders its cart drawer at the
       bottom of every page and firing cart:update at it from outside its own
       component makes it paint inline instead of as an overlay. */
    function addToCart(btn) {
      if (!current || !current.available) return;
      var label = btn.textContent;
      btn.classList.add('loading');
      btn.disabled = true;

      fetch(data.cartAddUrl + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: current.id, quantity: 1 }] })
      })
        .then(function (r) {
          if (!r.ok) {
            return r.json().then(function (j) {
              throw new Error(j.description || 'Could not add to cart');
            });
          }
          return r.json();
        })
        .then(function () {
          if (data.afterAdd === 'checkout') { window.location.href = '/checkout'; return; }
          if (data.afterAdd === 'stay') {
            btn.classList.remove('loading');
            btn.disabled = false;
            btn.textContent = data.addedLabel;
            setTimeout(render, 1800);
            return;
          }
          window.location.href = data.cartUrl;
        })
        .catch(function () {
          btn.classList.remove('loading');
          btn.disabled = false;
          btn.textContent = label;
          window.location.href = data.cartUrl;
        });
    }

    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        addToCart(elAtc);
      });
    }
    if (skBtn) {
      skBtn.addEventListener('click', function () { addToCart(skBtn); });
    }

    /* sticky bar */
    if (sticky && elAtc) {
      var shown = false;
      var toggleSticky = function () {
        var r = elAtc.getBoundingClientRect();
        var past = r.bottom < 0;
        var atBottom = window.innerHeight + window.scrollY >= document.body.offsetHeight - 140;
        var want = past && !atBottom;
        if (want !== shown) {
          shown = want;
          sticky.classList.toggle('on', want);
          sticky.setAttribute('aria-hidden', String(!want));
        }
      };
      window.addEventListener('scroll', toggleSticky, { passive: true });
      window.addEventListener('resize', toggleSticky);
      toggleSticky();
    }

    /* delivery estimate */
    var eta = byId('rz-eta');
    if (eta) {
      var lo = data.shipMin, hi = data.shipMax;
      if (hi < lo) { var t = lo; lo = hi; hi = t; }
      var d1 = new Date(); d1.setDate(d1.getDate() + lo);
      var d2 = new Date(); d2.setDate(d2.getDate() + hi);
      var loc = data.locale || 'en-GB';
      var sameMonth = d1.getMonth() === d2.getMonth() && d1.getFullYear() === d2.getFullYear();
      try {
        eta.textContent = sameMonth
          ? d1.toLocaleDateString(loc, { day: 'numeric' }) + ' \u2013 ' +
            d2.toLocaleDateString(loc, { day: 'numeric', month: 'short' })
          : d1.toLocaleDateString(loc, { day: 'numeric', month: 'short' }) + ' \u2013 ' +
            d2.toLocaleDateString(loc, { day: 'numeric', month: 'short' });
      } catch (e) {
        eta.textContent = d1.toISOString().slice(0, 10) + ' \u2013 ' + d2.toISOString().slice(0, 10);
      }
    }

    render();
  }

  function boot() {
    [].slice.call(document.querySelectorAll('[data-rz]')).forEach(function (root) {
      if (root.dataset.rzReady === '1') return;
      root.dataset.rzReady = '1';
      init(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
